"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('viewModels/deviceViewModel',["require", "exports", "knockout", "services/deviceService", "moment"], function (require, exports, ko, deviceService, moment) {
    "use strict";

    var DeviceViewModel = function () {
        function DeviceViewModel() {
            _classCallCheck(this, DeviceViewModel);

            this.selectedDevicePreview = ko.observable(null);
            this.selectedDevice = ko.observable(null);
            this.foundDevices = ko.observableArray([]);
            this.allocations = ko.observableArray([]);
            this.allocationsLoaded = ko.observable(false);
            this.batteryPercentage = ko.observable(0);
            this.lastChargedDate = ko.observable(null);
            this.lastFullChargeDate = ko.observable(null);
            this.chargingCycleCount = ko.observable(0);
            this.fullyChargedCount = ko.observable(0);
            this.totalChargeTime = ko.observable(0);
            this.batteryStatusLoaded = ko.observable(false);
            this.isCharging = ko.observable(false);
            this.cellVoltage = ko.observable(0);
            this.deviceData = ko.observableArray([]);
            this.deviceDataLoaded = ko.observable(false);
            this.deviceDetailsHistory = ko.observableArray([]);
            this.deviceDetailsHistoryLoaded = ko.observable(false);
            this.communicationsStatus = ko.observable('');
            this.lastPacketReceivedDate = ko.observable(null);
            this.communicationsStatusLoaded = ko.observable(false);
            this.deviceEnvironments = ko.observableArray([]);
            this.deviceOwners = ko.observableArray([]);
            this.deviceLocations = ko.observableArray([]);
            this.deviceStatuses = ko.observableArray([]);
            this.barcodeInput = ko.observable('');
            this.tileIndex = 200;
            this.setupBarcodeReader();
        }

        _createClass(DeviceViewModel, [{
            key: "setupBarcodeReader",
            value: function setupBarcodeReader() {
                var timeoutHandler = null;
                var inputString = '';
                $(document).keydown(function (e) {
                    if (timeoutHandler) {
                        clearTimeout(timeoutHandler);
                    }
                    if (e.keyCode !== 13 && e.keyCode !== 16) {
                        inputString += e.key || String.fromCharCode(e.keyCode);
                    }
                    timeoutHandler = setTimeout($.proxy(function () {
                        if (inputString.length >= 15) {
                            this.barcodeInput(inputString);
                        }
                        inputString = '';
                    }, this), 100);
                }.bind(this));
            }
        }, {
            key: "getNewIndex",
            value: function getNewIndex(tileId) {
                this.tileIndex++;
                return { id: tileId, index: this.tileIndex };
            }
        }, {
            key: "setSelectedDevicePreview",
            value: function setSelectedDevicePreview(device) {
                this.selectedDevicePreview(device);
            }
        }, {
            key: "setSelectedDevice",
            value: function setSelectedDevice(device) {
                this.selectedDevice(device);
            }
        }, {
            key: "loadDeviceDetailsHistory",
            value: function loadDeviceDetailsHistory() {
                this.deviceDetailsHistoryLoaded(false);
                this.deviceDetailsHistory.removeAll();
                return deviceService.getDeviceDetailsHistory(this.selectedDevice().boxId, this.selectedDevice().unitSerialNumber).then(this.setDeviceDetailsHistory.bind(this));
            }
        }, {
            key: "setDeviceDetailsHistory",
            value: function setDeviceDetailsHistory(deviceDetailsHistory) {
                this.deviceDetailsHistory(deviceDetailsHistory);
                this.deviceDetailsHistoryLoaded(true);
            }
        }, {
            key: "loadAllocations",
            value: function loadAllocations() {
                this.allocationsLoaded(false);
                this.allocations.removeAll();
                deviceService.getAllocations(this.selectedDevice().boxId, this.selectedDevice().unitSerialNumber).then(this.setAllocations.bind(this));
            }
        }, {
            key: "setAllocations",
            value: function setAllocations(allocations) {
                this.allocations(allocations);
                this.allocationsLoaded(true);
            }
        }, {
            key: "loadBatteryStatus",
            value: function loadBatteryStatus() {
                this.batteryStatusLoaded(false);
                var date = moment(this.selectedDevice().created);
                deviceService.getBatteryStatus(this.selectedDevice().boxId, this.selectedDevice().environment.toLowerCase(), date.format('YYYY-MM-DD')).then(this.setBatteryStatus.bind(this));
            }
        }, {
            key: "setBatteryStatus",
            value: function setBatteryStatus(batteryStatus) {
                this.lastChargedDate(batteryStatus.lastChargedDate);
                this.lastFullChargeDate(batteryStatus.lastFullChargeDate);
                this.chargingCycleCount(batteryStatus.chargingCycleCount);
                this.fullyChargedCount(batteryStatus.fullyChargedCount);
                this.totalChargeTime(batteryStatus.totalChargeDurationSeconds);
                this.batteryPercentage(batteryStatus.batteryPercentage);
                this.isCharging(batteryStatus.isCharging);
                this.cellVoltage(batteryStatus.cellVoltage);
                this.batteryStatusLoaded(true);
            }
        }, {
            key: "loadDataSummary",
            value: function loadDataSummary() {
                this.deviceDataLoaded(false);
                this.deviceData.removeAll();
                var date = moment(this.selectedDevice().created);
                deviceService.getData(this.selectedDevice().boxId, this.selectedDevice().environment, 11, date.format('YYYY-MM-DD')).then(this.setDataSummary.bind(this));
            }
        }, {
            key: "setDataSummary",
            value: function setDataSummary(deviceData) {
                if (deviceData) {
                    this.deviceData(deviceData.data);
                }
                this.deviceDataLoaded(true);
            }
        }, {
            key: "loadCommunicationsStatus",
            value: function loadCommunicationsStatus() {
                this.communicationsStatusLoaded(false);
                this.communicationsStatus('');
                this.lastPacketReceivedDate(null);
                var date = moment(this.selectedDevice().created);
                deviceService.getCommunicationsStatus(this.selectedDevice().boxId, this.selectedDevice().environment.toLowerCase(), date.format('YYYY-MM-DD')).then(this.setCommunicationsStatus.bind(this));
            }
        }, {
            key: "setCommunicationsStatus",
            value: function setCommunicationsStatus(communicationsStatus) {
                this.communicationsStatus(communicationsStatus.status);
                this.lastPacketReceivedDate(communicationsStatus.lastPacketReceived);
                this.communicationsStatusLoaded(true);
            }
        }, {
            key: "updateCommunicationsStatus",
            value: function updateCommunicationsStatus() {
                var communicationsStatus = this.communicationsStatus();
                this.communicationsStatus('');
                this.lastPacketReceivedDate(null);
                if (communicationsStatus !== 'Hibernating') {
                    deviceService.hibernateDevice(this.selectedDevice().boxId, this.selectedDevice().unitSerialNumber, this.selectedDevice().environment.toLowerCase()).then(this.setCommunicationsStatus.bind(this));
                }
                if (communicationsStatus === 'Hibernating') {
                    deviceService.wakeUpDevice(this.selectedDevice().boxId, this.selectedDevice().unitSerialNumber, this.selectedDevice().environment.toLowerCase()).then(this.setCommunicationsStatus.bind(this));
                }
            }
        }, {
            key: "getAvailableEnvironments",
            value: function getAvailableEnvironments() {
                return deviceService.getAvailableEnvironments().then(this.deviceEnvironments.bind(this));
            }
        }, {
            key: "getAvailableOwners",
            value: function getAvailableOwners() {
                return deviceService.getAvailableOwners().then(this.deviceOwners.bind(this));
            }
        }, {
            key: "getAvailableLocations",
            value: function getAvailableLocations() {
                return deviceService.getAvailableLocations().then(this.deviceLocations.bind(this));
            }
        }, {
            key: "getAvailableStatuses",
            value: function getAvailableStatuses() {
                return deviceService.getAvailableStatuses().then(this.deviceStatuses.bind(this));
            }
        }, {
            key: "updateDevice",
            value: function updateDevice(environmentId, ownerId, locationId, statusId, otherLocation, reason) {
                var _this = this;

                var deferred = $.Deferred();
                var device = this.selectedDevice();
                device.environment = environmentId;
                device.owner = ownerId;
                device.location = locationId;
                device.status = statusId;
                device.otherLocation = otherLocation;
                device.reason = reason;
                deviceService.updateDevice(device, 'DeviceDetails').then(function (device) {
                    _this.setSelectedDevice(device);
                    deferred.resolve(device);
                });
                return deferred.promise();
            }
        }, {
            key: "clear",
            value: function clear() {
                this.foundDevices.removeAll();
                this.selectedDevicePreview(null);
                this.selectedDevice(null);
                this.allocations.removeAll();
                this.allocationsLoaded(false);
                this.batteryPercentage(0);
                this.lastChargedDate(null);
                this.lastFullChargeDate(null);
                this.chargingCycleCount(0);
                this.fullyChargedCount(0);
                this.totalChargeTime(0);
                this.batteryStatusLoaded(false);
                this.isCharging(false);
                this.deviceData.removeAll();
                this.deviceDataLoaded(false);
                this.communicationsStatus('');
                this.lastPacketReceivedDate(null);
                this.communicationsStatusLoaded(false);
            }
        }]);

        return DeviceViewModel;
    }();

    return new DeviceViewModel();
});
//# sourceMappingURL=deviceViewModel.js.map;
